import { RefObject, useCallback, useEffect, useState } from "react";

export function useSticky(
  containerRef: RefObject<HTMLDivElement>,
  offsetTop: number
): boolean {
  const [sticky, setSticky] = useState(false);

  const handleScroll = useCallback(() => {
    if (!containerRef.current) return;

    const newSticky =
      window.scrollY > containerRef.current.offsetTop - offsetTop;

    if (newSticky !== sticky) {
      setSticky(newSticky);
    }
  }, [sticky, containerRef, offsetTop]);

  useEffect(() => {
    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => document.removeEventListener("scroll", handleScroll);
  }, [sticky, offsetTop, handleScroll]);

  return sticky;
}
